import { apiClient } from './axiosInstance';

export const fetchTimesheetsMembersFilterList = async () => {
  return await apiClient.get('/time-entries/members');
};

export const fetchMemberTimesheetsInfo = async (memberId: number) => {
  return await apiClient.get(`/time-entries/members/${memberId}`);
};
